<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { LOCAL_STORAGE_KEYS } from 'dashboard/constants/localStorage';
import { LocalStorage } from 'shared/helpers/localStorage';
import { mapGetters } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { useAdmin } from 'dashboard/composables/useAdmin';

export default {
  components: { Banner },
  setup() {
    const { accountId } = useAccount();
    const { isAdmin } = useAdmin();

    return {
      accountId,
      isAdmin,
    };
  },
  data() {
    return {
      sessionDismissed: false,
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
    }),
    account() {
      return this.getAccount(this.accountId);
    },
    aiCredits() {
      return this.account?.ai_credits || {};
    },
    isDismissedPermanently() {
      return Boolean(
        LocalStorage.getFromJsonStore(
          LOCAL_STORAGE_KEYS.DISMISSED_AI_CREDITS_EXHAUSTED_BANNER,
          this.accountId
        )
      );
    },
    shouldShowBanner() {
      return (
        this.isAdmin &&
        // Sem nenhum bot de IA a conta não tem como gastar crédito, então cobrar recarga
        // é ruído em cima de quem nem usa o recurso.
        this.aiCredits?.has_ai_agents &&
        this.aiCredits?.exhausted &&
        !this.sessionDismissed &&
        !this.isDismissedPermanently
      );
    },
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.AI_CREDITS_EXHAUSTED.MESSAGE');
    },
  },
  watch: {
    aiCredits: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value?.exhausted) {
          return;
        }

        LocalStorage.deleteFromJsonStore(
          LOCAL_STORAGE_KEYS.DISMISSED_AI_CREDITS_EXHAUSTED_BANNER,
          this.accountId
        );
        this.sessionDismissed = false;
      },
    },
  },
  methods: {
    dismissCurrentSession() {
      this.sessionDismissed = true;
    },
    dismissPermanently() {
      LocalStorage.updateJsonStore(
        LOCAL_STORAGE_KEYS.DISMISSED_AI_CREDITS_EXHAUSTED_BANNER,
        this.accountId,
        true
      );
      this.sessionDismissed = true;
    },
  },
};
</script>

<template>
  <Banner
    v-if="shouldShowBanner"
    color-scheme="alert"
    :banner-message="bannerMessage"
    :action-button-label="$t('GENERAL_SETTINGS.AI_CREDITS_EXHAUSTED.DONT_SHOW_AGAIN')"
    action-button-variant="smooth"
    has-action-button
    has-close-button
    @click="dismissPermanently"
    @close="dismissCurrentSession"
  />
</template>
